import { Media } from '@/payload-types'

export const getAltTag = (media: Media | string | undefined | null, fallback: string) => {
  if (!media) return fallback
  if (typeof media === 'string') {
    return media
  }
  return media.alt || fallback
}
